import React from 'react';

export interface IconLovebrandProps {
  className?: string;
  size?: number | string;
  color?: string;
  fill?: string;
  stroke?: string;
}

const IconLovebrand: React.FC<IconLovebrandProps> = ({ 
  className = '', 
  size = 24, 
  color = 'currentColor', 
  fill, 
  stroke 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      color={color}
      fill={fill || 'none'}
    >
       <path d="M29 12.3377C29 14.2735 28.6204 15.7098 27.2255 17.2041C27.0461 17.3963 26.7415 17.6735 26.7415 17.6735L16.0942 28L5.4469 17.6735L4.96294 17.2041C2.11719 14.3431 2.47695 10.0284 5.3227 7.16741C8.19641 4.27833 12.878 4.27833 15.7517 7.16741L16.0939 7.51144L16.4359 7.16761C17.8138 5.78169 19.6903 5 21.6505 5C23.6108 5 25.4872 5.78161 26.8651 7.16741C28.2338 8.54288 29 10.4021 29 12.3377Z" stroke={stroke || "#020617"}  strokeWidth="1.5" />  
    </svg>
  );
};

export default IconLovebrand;
